module.exports = __webpack_public_path__ + "img/candlestick.e0bb8875.jpeg";